// FORGED Ed Systems — DEPLOY003 — v0.3.0 — IntakeStep2Curriculum.tsx
// Last touched: 2026-05-19
//
// Step 2 of intake: Which curriculum framework should we evaluate against?
// FORGED Code-First option appears only if pilot_code_redeemed is set.

import type { EvaluationCurriculum } from "./types";

type CurriculumOption = {
  id: EvaluationCurriculum;
  label: string;
  description: string;
  requiresPilot?: boolean;
};

const OPTIONS: CurriculumOption[] = [
  {
    id: "aws_sense",
    label: "AWS SENSE",
    description:
      "American Welding Society Entry / Advanced / Expert. US-native standard; aligns with TX TEKS pathway.",
  },
  {
    id: "nccer_welding",
    label: "NCCER Welding",
    description:
      "National Center for Construction Education and Research, Level 1-3; widely used in TX construction-trade CTE.",
  },
  {
    id: "american_welding_program",
    label: "The American Welding Program (AWP)",
    description:
      "EWI + CWB Group joint venture (Columbus OH + Ontario). AWS SENSE-aligned (not AWS-endorsed).",
  },
  {
    id: "tx_teks_teacher_generated",
    label: "TX TEKS — Teacher-Generated",
    description:
      "Your own TEKS-aligned curriculum, or one you inherited. We'll work from §130.362-.364.",
  },
  {
    id: "forged_code_first",
    label: "FORGED Code-First Curriculum (pilot)",
    description:
      "Code-First / Inspector-Before-Arc / Pre-Arc 4-Zone methodology. Pilot participants only.",
    requiresPilot: true,
  },
];

type Props = {
  value: EvaluationCurriculum | null;
  pilotCodeRedeemed: string | null;
  onChange: (v: EvaluationCurriculum) => void;
};

export default function IntakeStep2Curriculum({
  value,
  pilotCodeRedeemed,
  onChange,
}: Props) {
  const visible = OPTIONS.filter(
    (o) => !o.requiresPilot || pilotCodeRedeemed != null
  );

  return (
    <div>
      <h2>Which curriculum framework should we evaluate against?</h2>
      <p className="step-description">
        This is the curriculum we'll measure your operational fit against and
        build the plan around. You can run additional plans against other
        curricula by submitting again — each plan stays in your dashboard.
      </p>

      <div className="curriculum-card-stack">
        {visible.map((opt) => {
          const selected = value === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => onChange(opt.id)}
              className={
                "curriculum-card" + (selected ? " curriculum-card-selected" : "")
              }
            >
              <div className="curriculum-card-radio">{selected ? "●" : "○"}</div>
              <div className="curriculum-card-body">
                <div className="curriculum-card-label">{opt.label}</div>
                <div className="curriculum-card-description">{opt.description}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
